<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-exposure__exposure">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.title" placeholder="标题" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.type" placeholder="类型" clearable @change="getPage()">
            <el-option label="点赞" :value=exposureType.fabulous></el-option>
            <el-option label="曝光" :value=exposureType.exposure></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.auditStatus" placeholder="审核状态" clearable>
            <el-option :value="auditStatus.examine" label="审核中"></el-option>
            <el-option :value="auditStatus.passed" label="已通过"></el-option>
            <el-option :value="auditStatus.fail" label="未通过"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
                  v-model="createDate"
                  @change="getPage()"
                  type="daterange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <!--<el-form-item>
          <el-button v-if="$hasPermission('exposure:exposure:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('exposure:exposure:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>-->
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="title" label="标题" header-align="center" align="center"></el-table-column>
        <el-table-column prop="type" label="类型" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.type===exposureType.fabulous">点赞</el-tag>
            <el-tag v-if="scope.row.type===exposureType.exposure">曝光</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createDate" label="上传时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="teacherName" label="上传人员" header-align="center" align="center"></el-table-column>
        <el-table-column prop="auditStatus" label="审核状态" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag type="warning" v-if="scope.row.auditStatus===auditStatus.examine">审核中</el-tag>
            <el-tag type="success" v-if="scope.row.auditStatus===auditStatus.passed">已通过</el-tag>
            <el-tag type="danger" v-if="scope.row.auditStatus===auditStatus.fail">未通过</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="rejectionReason" label="驳回原因" header-align="center" align="center"></el-table-column>
        <el-table-column prop="resubmit" label="重新提交" header-align="center" align="center"></el-table-column>
        <el-table-column prop="passTime" label="通过时间" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('exposure:exposure:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="scope.row.auditStatus===auditStatus.examine" type="text" size="small" @click="passHandle(scope.row)">通过并发布</el-button>
            <el-button v-if="scope.row.auditStatus===auditStatus.examine" type="text" size="small" @click="failHandle(scope.row)">不通过</el-button>
            <el-button v-if="$hasPermission('exposure:exposure:update')" type="text" size="small" @click="viewHandle(scope.row.id)">查看</el-button>
            <!--<el-button v-if="$hasPermission('exposure:exposure:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>-->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
      <view-exposure v-if="viewVisible" ref="viewExposure" @refreshDataList="getDataList"></view-exposure>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import { exposureType, auditStatus } from '../../../constant'
import AddOrUpdate from './exposure-add-or-update'
import ViewExposure from './view-exposure'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/exposure/exposure/examinePage',
        getDataListIsPage: true,
        exportURL: '/exposure/exposure/export',
        deleteURL: '/exposure/exposure',
        deleteIsBatch: true
      },
      viewVisible: false,
      exposureType,
      auditStatus,
      createDate: [],
      dataForm: {
        type: '',
        createTime: '',
        endCreateTime: ''
      }
    }
  },
  methods: {
    getPage () {
      if (this.createDate === null || this.createDate.length <= 1) {
        this.dataForm.createTime = ''
        this.dataForm.endCreateTime = ''
        this.createDate = []
        return this.getDataList()
      }
      const date = new Date(this.createDate[0])
      this.dataForm.createTime = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + '00:00:00'
      const date2 = new Date(this.createDate[1])
      this.dataForm.endCreateTime = date2.getFullYear() + '-' + (date2.getMonth() + 1) + '-' + date2.getDate() + ' ' + '23:59:59'
      this.getDataList()
    },
    viewHandle (id) {
      this.viewVisible = true
      this.$nextTick(() => {
        this.$refs.viewExposure.dataForm.id = id
        this.$refs.viewExposure.init()
      })
    },
    // 通过并发布
    passHandle (item) {
      this.$http.get('/exposure/exposure/passAndPublish/' + item.id).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.query()
        this.$notify({
          type: 'info',
          duration: '750',
          message: '通过并发布成功'
        })
      })
    },
    // 不通过
    failHandle (item) {
      this.$http.get('/exposure/exposure/unPass/' + item.id).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.query()
        this.$notify({
          type: 'info',
          duration: '750',
          message: '不通过成功'
        })
      })
    }
  },
  watch: {
  },
  components: {
    AddOrUpdate,
    ViewExposure
  }
}
</script>
